'use client';

import React from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';

export type FormProps = {
  form: UseFormReturn<any>;
} & React.DetailedHTMLProps<
  React.FormHTMLAttributes<HTMLFormElement>,
  HTMLFormElement
>;

export function Form({ form, children, ...rest }: FormProps) {
  return (
    <FormProvider {...form}>
      <form {...rest}>{children}</form>
    </FormProvider>
  );
}
